// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3xs9L","header":"ReportDetails_header__1IG_j","title":"ReportDetails_title__TFwY5","left":"ReportDetails_left__1nyR9"};